var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-sm a-infoBar a-infoBar--warning"},[_vm._v(" Wpisz kod lokalny (bez znaków zapytania), który będzie wykorzystywany na urządzeniu fiskalnym. Dzięki temu promocja zadziała poprawnie. "),(_vm.$store.getters.isProductEansPermission)?_c('span',[_vm._v("Zadeklarowane kody zostaną zapisane w bazie kodów lokalnych.")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }